import { Component, inject, OnInit } from '@angular/core';
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { RatingType } from '@empathy/survey/base';

import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-rank-sort-form',
  templateUrl: './rank-sort-form.component.html',
  styleUrls: ['./rank-sort-form.component.scss', '_rank-sort-form-theme.component.scss']
})
export class RankSortFormComponent implements OnInit {
  faMinus = faMinus;
  faPlus = faPlus;
  ratingType = RatingType;

  public surveyEditorService = inject(SurveyEditorService);

  ngOnInit(): void {
    this.surveyEditorService
      .surveyEditor$()
      .activeQuestion.get('ratingScale')
      .valueChanges.subscribe((ratingScale) => {
        const minRank = this.surveyEditorService.surveyEditor$().activeQuestion.get('minRank');

        if (!!minRank.value && !!ratingScale && minRank.value > ratingScale) {
          minRank.setValue(ratingScale);
        } else if (!ratingScale) {
          minRank.setValue(1);
        }
      });
  }

  onRoundNumber(): void {
    let currentScale = this.surveyEditorService.surveyEditor$().activeQuestion.get('minRank').value;
    currentScale = Math.ceil(currentScale);
    this.surveyEditorService.surveyEditor$().activeQuestion.get('minRank').setValue(currentScale);
  }

  onIncreaseScale(): void {
    let currentScale = this.surveyEditorService.surveyEditor$().activeQuestion.get('minRank').value;
    currentScale++;
    this.surveyEditorService.surveyEditor$().activeQuestion.get('minRank').setValue(currentScale);
  }

  onDecreaseScale(): void {
    let currentScale = this.surveyEditorService.surveyEditor$().activeQuestion.get('minRank').value;
    currentScale--;
    this.surveyEditorService.surveyEditor$().activeQuestion.get('minRank').setValue(currentScale);
  }

  onMinimumRatingInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const value = parseFloat(inputElement.value);
    const isNumeric = this.surveyEditorService.surveyEditor$().activeQuestion.get('ratingType').value === this.ratingType.numeric;

    if (isNaN(value) || value < 1) {
      this.surveyEditorService.surveyEditor$().activeQuestion.get('minRank').setValue(1);
      inputElement.value = '1';
      return;
    }

    if (
      isNumeric
        ? value > this.surveyEditorService.surveyEditor$().activeQuestion.get('ratingScale').value
        : value > this.surveyEditorService.surveyEditor$().activeQuestion.get('ranks').value.length
    ) {
      this.surveyEditorService
        .surveyEditor$()
        .activeQuestion.get('minRank')
        .setValue(
          isNumeric
            ? this.surveyEditorService.surveyEditor$().activeQuestion.get('ratingScale').value
            : this.surveyEditorService.surveyEditor$().activeQuestion.get('ranks').value.length
        );
      return;
    }

    this.surveyEditorService.surveyEditor$().activeQuestion.get('minRank').setValue(value);
  }
}
